import './PurchaseOrderStatusBadge.css'

const PurchaseOrderStatusBadge = ({ status }) => {
  const getStatusConfig = (status) => {
    const configs = {
      pending: { label: 'Pendiente', className: 'status-pending' },
      confirmed: { label: 'Confirmado', className: 'status-confirmed' },
      partially_paid: { label: 'Pago Parcial', className: 'status-partially-paid' },
      paid: { label: 'Pagado', className: 'status-paid' },
      partially_received: { label: 'Recepción Parcial', className: 'status-partially-received' },
      received: { label: 'Recibido', className: 'status-received' },
      completed: { label: 'Completado', className: 'status-completed' },
      cancelled: { label: 'Cancelado', className: 'status-cancelled' }
    }
    return configs[status] || { label: status, className: 'status-unknown' }
  }

  const config = getStatusConfig(status)

  return (
    <span className={`purchase-order-status-badge ${config.className}`}>
      {config.label}
    </span>
  )
}

export default PurchaseOrderStatusBadge

